import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import './styles.scss'

function RadioButton({
  id,
  name,
  value,
  checked,
  small,
  label,
  bold,
  icon,
  dark,
  className,
  disabled,
  onChange,
  readOnly
}) {
  const [isChecked, setChecked] = useState(false)

  useEffect(() => {
    setChecked(checked)
  }, [checked])

  const handleClick = () => {
    if (!isChecked) {
      setChecked(true)
      onChange({ id, name, value })
    }
  }

  return (
    <div
      className={cn(
        'radio-button-container',
        className,
        icon && label ? 'three-columns' : icon || label ? 'two-coluns' : '',
        { disabled, 'read-only': readOnly }
      )}
      onClick={readOnly ? undefined : handleClick}
    >
      <input
        id={id}
        name={name}
        type='radio'
        className={cn({ small })}
        checked={checked}
        disabled={disabled}
        readOnly
      />
      {label && (
        <span
          className={cn('radio-button__label truncate', {
            'text bold': bold,
            'text dark': dark,
            disabled
          })}
        >
          {label}
        </span>
      )}
      {icon}
    </div>
  )
}

export default RadioButton
